/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminOSG
 */
export interface InputAdminOSG {
    /**
     * 
     * @type {string}
     * @memberof InputAdminOSG
     */
    name: string;
}

/**
 * Check if a given object implements the InputAdminOSG interface.
 */
export function instanceOfInputAdminOSG(value: object): boolean {
    if (!('name' in value)) return false;
    return true;
}

export function InputAdminOSGFromJSON(json: any): InputAdminOSG {
    return InputAdminOSGFromJSONTyped(json, false);
}

export function InputAdminOSGFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminOSG {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function InputAdminOSGToJSON(value?: InputAdminOSG | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

